import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnInit, Renderer2, ViewEncapsulation } from '@angular/core';
import { Route, Router, RoutesRecognized } from '@angular/router';
import { NotificationsService } from 'bowman-angular2-notifications';
import { BowmanCacheService } from 'bowman-cache';
import { BowmanLogger, BowmanLoggerService } from 'bowman-logger';
import { forkJoin, Observable, Observer, Subscription } from 'rxjs';
import { DynamicModuleService } from 'src/services/dynamic-module.service';
import { CustomizationConfiguration } from 'src/services/model/customization-configuration';
import { SecurityService } from 'src/services/security.service';
import { User } from './model/user';
import { DashboardManagerService } from './services/dashboard-manager.service';


@Component({
     selector: 'app-root',
     templateUrl: './app.component.html',
     styleUrls: ['./app.component.scss'],
     providers: [
          SecurityService,
          DashboardManagerService,
          DynamicModuleService
     ],
     encapsulation: ViewEncapsulation.None,
     changeDetection: ChangeDetectionStrategy.OnPush
})
export class AppComponent implements OnInit {
     private log: BowmanLogger = new BowmanLogger(this._loggerService, "App component");
     @Input() public serverVersion: string;
     @Input() public frontendVersion: string;
     @Input() public currentUser: User;
     @Input() public customization: CustomizationConfiguration;
     public routes: any;
     public currentYear: string = new Date().getFullYear().toString();
     private previousUrl: string;
     private installedModules$: any;
     public appInitialized: boolean = false;
     public busy: Subscription;



     constructor(
          private _router: Router,
          private _dynamicModuleService: DynamicModuleService,
          private renderer: Renderer2,
          private _notificationServices: NotificationsService,
          private _loggerService: BowmanLoggerService,
          private _bowmanCacheService: BowmanCacheService,
          private _cdr: ChangeDetectorRef,
     ) { }


      ngOnInit() {
          this.installedModules$ = this._dynamicModuleService.loadModules().subscribe(res => {
               this.appInitialized = true;
               if (this._router.url == '/') {
                    if (this.customization != null && this.customization.sections && this.customization.sections != null && this.customization.sections.length > 0) {
                         if (this.customization.startSection != null) {
                              this._router.navigate([this.customization.startSection]);
                         } else {
                              this._router.navigate([this.customization.sections[0]]);
                         }
                    } else {
                         this._router.navigate(['discovery']);
                    }
               } else {
                    this._router.navigate([this._router.url]);
               }
               this._cdr.detectChanges();
          }, err => {
               this._notificationServices.error(`Unable to load dynamic modules list:`, err);
               this.log.error(`Unable to load dynamic modules list:`, err);
          })


          this._router.events
               .subscribe((event) => {
                    if (event instanceof RoutesRecognized) {
                         if (this.previousUrl) {
                              this.renderer.removeClass(document.body, this.previousUrl);
                         }
                         let currentUrlSlug = event.url.slice(1).split('/')[0];
                         if (event.url.slice(1).split('/').length > 2) {
                              currentUrlSlug = 'dashboard-view';
                         }
                         if (currentUrlSlug) {
                              this.renderer.addClass(document.body, currentUrlSlug);
                         }
                         this.previousUrl = currentUrlSlug;
                    }
               });
     }


}
